<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
    <path d="M11.95 6.35C11.95 9.85 6.35 14.75 6.35 14.75C6.35 14.75 0.75 9.85 0.75 6.35C0.75 4.86479 1.34 3.44041 2.3902 2.3902C3.44041 1.34 4.86479 0.75 6.35 0.75C7.83521 0.75 9.25959 1.34 10.3098 2.3902C11.36 3.44041 11.95 4.86479 11.95 6.35Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
    <path d="M8.09961 6.3501C8.09961 7.3166 7.31611 8.1001 6.34961 8.1001C5.38311 8.1001 4.59961 7.3166 4.59961 6.3501C4.59961 5.3836 5.38311 4.6001 6.34961 4.6001C7.31611 4.6001 8.09961 5.3836 8.09961 6.3501Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="var(--Shades-00)"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconLocale'
}
</script>
